import PageLayout from '../components/PageLayout'
import Spinner from '../components/Spinner'

export default function LoadingPage() {
  return (
    <PageLayout>
      <div className="flex grow flex-col items-center justify-center">
        <Spinner />
      </div>
    </PageLayout>
  )
}
